document.addEventListener("DOMContentLoaded", () => {
    let div = document.querySelector('#fixed-nav');
    let totalHeight = document.body.scrollHeight;

    window.addEventListener('scroll', function () {
        let currentPosition = window.scrollY + window.innerHeight;

        if (window.scrollY > 500) {
            div.classList.add('show');
        } else {
            div.classList.remove('show');
        }
        if (currentPosition >= totalHeight - 75) {
            div.classList.remove('show');
        }
    });
});